import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import { OhsIncidentViewPresets, IncidentListsRecordState } from '../OhsIncidentModels';
import { fetchIncidentListsAsync } from './OhsIncidentActions';

const initialState: IncidentListsRecordState = {
  isLoading: false,
  incidentLists: null,
  currentPage: 1,
  currentViewPreset: OhsIncidentViewPresets.View2IncidentList,
};

export const incidentSlice = createSlice({
  name: 'incident',
  initialState,
  reducers: {
    setIncidentIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIncidentList: (state, action: any) => {
      if (state.incidentLists) {
        state.incidentLists = {
          pagination: state.incidentLists?.pagination,
          items: action.payload || [],
        };
      }
    },
    setCurrentRegisterPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setViewPreset: (state, action: PayloadAction<OhsIncidentViewPresets>) => {
      state.currentViewPreset = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncidentListsAsync.pending, (state) => {
        state.isLoading = true;
        state.incidentLists = {
          items: [],
          pagination: state.incidentLists?.pagination ?? {
            page: 0,
            totalPages: 0,
            next: '',
          },
        };
      })
      .addCase(fetchIncidentListsAsync.fulfilled, (state, action) => {
        if (action.payload.list) {
          state.incidentLists = action.payload.list;
          state.isLoading = false;

          let setItemsLastId = '';
          const incidentItems = [...state.incidentLists.items];
          if (incidentItems.length > 0)
            setItemsLastId = incidentItems[incidentItems.length - 1]?._id || '';

          state.incidentLists.pagination.next = setItemsLastId || '';
        }
        if (action.payload.count && state.incidentLists) {
          state.incidentLists.pagination.totalPages =
            action.payload.count?.pagination.totalPages ?? 0;
        }
      })
      .addCase(fetchIncidentListsAsync.rejected, (state) => {
        state.incidentLists = null;
      });
  },
});

// Memoized Selectors
const incidentState = (state: RootState) => state.incident;
export const getOhsIncidentLists = createSelector([incidentState], (incident) => incident);

export const { setIncidentIsLoading, setIncidentList, setCurrentRegisterPage, setViewPreset } =
  incidentSlice.actions;
export { fetchIncidentListsAsync };
export const incidentModuleReducer = incidentSlice.reducer;
